<template>
  <div class="loading-container">
    <div class="gladiator-loading">
      <div class="sword"></div>
      <div class="shield"></div>
      <div class="loading-text">Preparing for battle...</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.gladiator-loading {
  position: relative;
  width: 200px;
  height: 200px;
  animation: pulse 2s infinite;
}

.sword {
  position: absolute;
  width: 120px;
  height: 8px;
  background: linear-gradient(90deg, #696969, #c0c0c0);
  transform: rotate(45deg);
  left: 40px;
  top: 96px;
  
  &:before {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background: #ffd700;
    left: -15px;
    top: -11px;
    border-radius: 5px;
  }
}

.shield {
  position: absolute;
  width: 80px;
  height: 100px;
  background: linear-gradient(45deg, #8b0000, #cd853f);
  border-radius: 50% 50% 45% 45%;
  left: 60px;
  top: 50px;
  transform: rotate(-45deg);
  box-shadow: 0 0 20px rgba(139, 0, 0, 0.5);
  
  &:before {
    content: '';
    position: absolute;
    width: 60px;
    height: 80px;
    border: 4px solid #ffd700;
    border-radius: 50% 50% 45% 45%;
    left: 6px;
    top: 6px;
  }
}

.loading-text {
  position: absolute;
  bottom: -40px;
  width: 100%;
  text-align: center;
  color: #ffd700;
  font-size: 1.2em;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
  animation: textPulse 1.5s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

@keyframes textPulse {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}
</style>
